import { MdSettings } from "react-icons/md";
import PageTitle from "../../components/PageTitle/PageTitle";
import TwoSidebars from "../../layouts/TwoSidebars/TwoSidebars";
import ButtonGroup from "../../components/ButtonGroup/ButtonGroup";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import SettingsBlocks from "../../components/SettingsBlocks/SettingsBlocks";
import useMobile from "../../hooks/useMobile";

import { ICON_SIZES } from "../../helpers/constants";

const SettingsPage: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  return (
    <TwoSidebars right={isMobile ? null : null}>
      <div
        className={clsx([
          "flex",
          "flex-col",
          "w-full",
          "gap-2",
          "md:gap-2",
          "h-full",
        ])}
      >
        <div
          className={clsx([
            "flex",
            "flex-col",
            "w-full",
            "gap-2",
            "md:gap-2",
            "h-full",
          ])}
        >
          <PageTitle
            icon={<MdSettings size={ICON_SIZES.MD} />}
            title={t("settings.title")}
            subtitle={isMobile ? t("Ajustes generales") : ""}
            isLoading={false}
            rightSide={
              <>
                {!isMobile && (
                  <ButtonGroup align="right" gap={1} buttons={[]} />
                )}
              </>
            }
          />
          <div className="md:mt-4 flex w-full">
            <SettingsBlocks hideTitle />
          </div>
        </div>
      </div>
    </TwoSidebars>
  );
};

export default SettingsPage;
